'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const { getCategoryLink } = require('../../support/slug-helper');

function getCategoryList({ keyAuthData, categoryData }) {
  const values = keyAuthData.categories
    .map(item => categoryData.find(({ id }) => id === item.categoryId))
    .sort(({ name: a }, { name: b }) => (a === b ? 0 : a < b ? -1 : 1));

  return values;
}

function CategoryLinks({ keyAuthData, categoryData, routes }) {
  const list = getCategoryList({ keyAuthData, categoryData });

  return h('.category-links', [
    h('.category-links-inner', [
      h(
        'ul.category-links-list',
        {
          'data-bhw': 'BrowseCategories',
        },
        list.map(item =>
          h(
            'li.category-links-item',
            h(WithI18n, {}, i18n =>
              h(
                'a',
                getCategoryLink({
                  categoryName: i18n.t(`js.modules.category.Name.${item.id}`),
                  routes,
                }),
                i18n.t(`js.modules.category.Name.${item.id}`)
              )
            )
          )
        )
      ),
    ]),
  ]);
}

module.exports = CategoryLinks;
